( function () {
    'use strict';
    espresso.ecom.checkout = {};
    espresso.ecom.checkout.init = function () {
        espresso.ecom.checkout.cart();
        espresso.ecom.checkout.delivery();
        espresso.ecom.checkout.payment();
        espresso.ecom.checkout.approve();
        espresso.ecom.checkout.receipt();
    };
    espresso.ecom.checkout.cart = function () {
        var jCheckoutCartForm = jQuery( '.js-e-checkout-form-cart' ),
            jCheckoutCartFormOrderlineUpdated = jCheckoutCartForm.find( '.js-e-orderline-updated' );
        //Set update as default action on cart form
        jCheckoutCartForm.attr( 'action', jCheckoutCartForm.data( 'action-update' ) );
        jCheckoutCartForm.find( '.js-e-checkout-btn-next' ).on( 'click', function () {
            //Set next step checkout as action on cart form
            jCheckoutCartForm.attr( 'action', jCheckoutCartForm.data( 'action-checkout' ) );
        } );
        if ( history.length !== 0 ) {
            jCheckoutCartForm.find( '.js-e-checkout-btn-back' ).on( 'click', function ( event ) {
                event.preventDefault();
                if ( document.referrer.indexOf( 'checkout' ) !== -1 || document.referrer.indexOf( 'ID=1131' ) !== -1 ) {
                    location.href = this.href;
                }
                else {
                    history.back();
                }
            } );
        }
        if ( jCheckoutCartFormOrderlineUpdated.length === 1 ) {
            co3.util.scroll.toElement( jCheckoutCartFormOrderlineUpdated, jCheckoutCartFormOrderlineUpdated.height() * -1 );
            jCheckoutCartFormOrderlineUpdated.find( 'input' ).trigger( 'select' );
        }
        jCheckoutCartForm.on( 'keydown keypress keyup', '.js-e-orderline-quantity', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( event.type === 'keyup' ) {
                    jQuery( this ).closest( 'tr' ).find( '.js-e-orderline-btn-update-cart' ).click();
                }
            }
        } ).find( '.js-e-orderline-quantity' ).on( 'focus', function () {
            var jThisRow = jQuery( this ).closest( 'tr' );
            co3.util.scroll.toElement( jThisRow, jThisRow.height() * -1 );
        } );
    };
    espresso.ecom.checkout.delivery = function () {
        var jCheckoutDeliveryForm = jQuery( 'form[name="CheckoutDeliveryForm"]' );
        if ( jCheckoutDeliveryForm.length === 1 ) {
            jCheckoutDeliveryForm.find( '.PreviousStepButton' ).on( 'click', function () {
                jCheckoutDeliveryForm.off( 'submit' );
            } );
            espresso.ecom.checkout.customertype();
            espresso.ecom.checkout.delivery.selectMethod();
            espresso.ecom.checkout.newslettersubscribe();
            jQuery( '.e-checkout-actions a.btn-link, .e-cart-mini a.btn' ).on( 'click', function ( event ) {
                event.preventDefault();
                //submit ajax
                jQuery.post( location.href, jCheckoutDeliveryForm.serialize() ).success( function () {
                    location.href = jQuery( '.e-checkout-actions a.btn-link' ).attr( 'href' );
                } );
            } );
        }
    };
    espresso.ecom.checkout.customertype = function () {
        var jCo3EspressoCustomerType = jQuery( '#CustomerType' );
        jCo3EspressoCustomerType.find( 'input[name="Co3EspressoCustomerType"]' ).on( 'change', function () {
            if ( jCo3EspressoCustomerType.find( 'input[name="Co3EspressoCustomerType"]' ).filter( ':checked' ).val() === 'extranet' ) {
                jCo3EspressoCustomerType.find( '.js-e-login-modal-link' ).triggerHandler( 'click' );
            }
        } ).triggerHandler( 'change' );
    };
    espresso.ecom.checkout.newslettersubscribe = function () {
        jQuery( '#BillingAddress' ).find( 'input[name="Co3EspressoEcomOrderSubscribeToNewsletter"]' ).on( 'change', function () {
            jQuery( '#BillingAddress' ).find( 'input[name="EcomOrderSubscribeToNewsletter"]' ).val( this.checked === true ? 'true' : '' );
        } ).triggerHandler( 'change' );
    };
    espresso.ecom.checkout.delivery.selectMethod = function () {
        espresso.ecom.checkout.delivery.address.init();
        espresso.ecom.checkout.delivery.gls.init();
        espresso.ecom.checkout.delivery.postdk.init();
        var jShippingMethods = jQuery( '#ShippingMethods' ).find( 'input[name="EcomCartShippingmethodID"]' ).on( 'change', function () {
            if ( jQuery( this ).is( 'input[title*="GLS pakkeshop"]:checked' ) ) {
                espresso.ecom.checkout.delivery.gls.select();
                espresso.ecom.checkout.delivery.address.deSelect();
                espresso.ecom.checkout.delivery.postdk.deSelect();
            }
            else if ( jQuery( this ).is( 'input[title*="udleveringssted"]:checked' ) ) {
                espresso.ecom.checkout.delivery.postdk.select();
                espresso.ecom.checkout.delivery.address.deSelect();
                espresso.ecom.checkout.delivery.gls.deSelect();
            }
            else {
                espresso.ecom.checkout.delivery.address.select();
                espresso.ecom.checkout.delivery.gls.deSelect();
                espresso.ecom.checkout.delivery.postdk.deSelect();
            }
        } );
        if ( jShippingMethods.filter( ':checked' ).length === 0 ) {
            jShippingMethods.first().prop( 'checked', true );
        }
        jShippingMethods.filter( ':checked' ).triggerHandler( 'change' );
    };
    espresso.ecom.checkout.delivery.address = {};
    espresso.ecom.checkout.delivery.address.init = function () {
        jQuery( '#CustomerAddressIsDeliveryAddress' ).find( 'input[name="CustomerAddressIsDeliveryAddress"]' ).on( 'change', function () {
            if ( jQuery( this ).is( ':checked' ) === true && jQuery( this ).val() === 'true' ) {
                jQuery( '#DeliveryAddress' ).parent().slideUp( 'fast' );
                espresso.ecom.checkout.delivery.address.clear();
            }
            else {
                jQuery( '#DeliveryAddress' ).parent().slideDown( 'fast' );
                espresso.ecom.checkout.delivery.address.multiple();
            }
        } ).filter( ':checked' ).triggerHandler( 'change' );
    };
    espresso.ecom.checkout.delivery.address.select = function () {
        var customerAddressIsDeliveryAddress = jQuery( '#CustomerAddressIsDeliveryAddress' ).data( 'address' );
        if ( customerAddressIsDeliveryAddress !== '' ) {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).parent().slideDown( 'fast' ).find( 'input[name="CustomerAddressIsDeliveryAddress"][value="false"]' ).prop( 'checked', true ).triggerHandler( 'change' );
            jQuery( '#DeliveryAddressExtranet' ).find( 'input[name="CustomerAlternativeDeliveryAddress"][value="' + customerAddressIsDeliveryAddress + '"]' ).prop( 'checked', true ).triggerHandler( 'change' );
        }
        else {
            jQuery( '#CustomerAddressIsDeliveryAddress' ).parent().slideDown( 'fast' ).find( 'input[name="CustomerAddressIsDeliveryAddress"][value="true"]' ).prop( 'checked', true ).triggerHandler( 'change' );
        }
    };
    espresso.ecom.checkout.delivery.address.deSelect = function () {
        jQuery( '#CustomerAddressIsDeliveryAddress' ).parent().slideUp( 'fast' ).find( 'input[name="CustomerAddressIsDeliveryAddress"][value="true"]' ).prop( 'checked', true ).triggerHandler( 'change' );
        espresso.ecom.checkout.delivery.address.clear();
    };
    espresso.ecom.checkout.delivery.address.multiple = function () {
        jQuery( '#DeliveryAddressExtranet' ).find( 'input[name="CustomerAlternativeDeliveryAddress"]' ).on( 'change', function () {
            jQuery( this ).parent( 'label' ).find( 'span' ).each( function () {
                var customerAlternativeDeliveryAddressField = jQuery( this ).data( 'field' );
                jQuery( '#DeliveryAddress' ).find( 'input#' + customerAlternativeDeliveryAddressField ).val( jQuery.trim( jQuery( this ).text() ) );
            } );
        } ).filter( ':checked' ).triggerHandler( 'change' );
    };
    espresso.ecom.checkout.delivery.address.clear = function () {
        jQuery( '#DeliveryAddress' ).find( ':input' ).val( '' );
    };
    espresso.ecom.checkout.delivery.gls = {};
    espresso.ecom.checkout.delivery.gls.settings = {
        url: '/glslookup.ashx',
        jZipCodeInputField: jQuery( '#EcomOrderCustomerZip' )
    };
    espresso.ecom.checkout.delivery.gls.parcelshops = {};
    espresso.ecom.checkout.delivery.gls.init = function () {
        var jEspressoGLSshopSearchString = jQuery( '#EspressoGLSshopSearchString' ).on( 'change', function () {
            jEspressoGLSshopSearchString.data( 'changed', true );
        } );
        espresso.ecom.checkout.delivery.gls.settings.jZipCodeInputField.on( 'change', function () {
            //hvis man har ændret værdien i gls postnummer feltet eller allerede har valgt en pakkeshop skal der ikke laves et nyt opslag selv om kundens postnummer ændres sig
            if ( jEspressoGLSshopSearchString.data( 'changed' ) !== true && jQuery( '#DeliveryGLS input[name="gls-shop"]' ).filter( ':checked' ).length === 0 ) {
                jEspressoGLSshopSearchString.val( espresso.ecom.checkout.delivery.gls.settings.jZipCodeInputField.val() );
                jQuery( '#EspressoGLSshopSearchButton' ).triggerHandler( 'click' );
            }
        } );
        var jEspressoGLSshopSearchButton = jQuery( '#EspressoGLSshopSearchButton' ).on( 'click', function ( event ) {
            event.preventDefault();
            if ( jEspressoGLSshopSearchString.valid() ) {
                espresso.ecom.checkout.delivery.gls.lookup( jEspressoGLSshopSearchString.val() );
            }
        } );
        jEspressoGLSshopSearchString.on( 'keydown keypress keyup', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( event.type === 'keyup' ) {
                    jEspressoGLSshopSearchButton.triggerHandler( 'click' );
                }
            }
        } );
        jQuery( '#DeliveryGLS' ).on( 'change', 'input[name="gls-shop"]', function () {
            espresso.ecom.checkout.delivery.gls.selectShop( jQuery( this ).val() );
        } );
    };
    espresso.ecom.checkout.delivery.gls.select = function () {
        var jEspressoGLSshopSearchString = jQuery( '#EspressoGLSshopSearchString' ),
            jEspressoGLSshopID = jQuery( '#EspressoGLSshopID' );
        //Hvis disse 2 felter er udfyldt er de blevet sat via TemplateTags fordi brugeren har været i gang med checkout forløbet tidligere i samme session og i så fald skal gls-postnummerfeltet ikke opdateres selvom kunden postnummer ændre sig
        if ( jEspressoGLSshopSearchString.val() !== '' && jEspressoGLSshopID.val() !== '' ) {
            jEspressoGLSshopSearchString.data( 'changed', true );
        }
        //Hvis postnummer feltet er udfyldt med andet end postnummer fra kundeinfo og det er valideret skal der laves et nyt opslag
        if ( jEspressoGLSshopSearchString.data( 'changed' ) === true && jEspressoGLSshopSearchString.valid() ) {
            espresso.ecom.checkout.delivery.gls.lookup( jEspressoGLSshopSearchString.val() );
        }
        else {
            espresso.ecom.checkout.delivery.gls.lookup( espresso.ecom.checkout.delivery.gls.settings.jZipCodeInputField.val() );
            jEspressoGLSshopSearchString.val( espresso.ecom.checkout.delivery.gls.settings.jZipCodeInputField.val() );
            jEspressoGLSshopID.val( '' );
        }
        jQuery( '#DeliveryGLS' ).parent().slideDown( 'fast' );
    };
    espresso.ecom.checkout.delivery.gls.deSelect = function () {
        //Nulstil alt hvad der har med gls at gøre
        espresso.ecom.checkout.delivery.address.clear();
        jQuery( '#EspressoGLSshopSearchString' ).val( '' ).data( 'changed', false );
        jQuery( '#EspressoGLSshopID' ).val( '' );
        jQuery( '#DeliveryGLS' ).parent().slideUp( 'fast' );
    };
    espresso.ecom.checkout.delivery.gls.lookup = function ( strZipCode ) {
        var url = espresso.ecom.checkout.delivery.gls.settings.url + '?type=ZIP&zipcode=' + encodeURIComponent( jQuery.trim( strZipCode ) );
        jQuery.get( url, function ( data ) {
            espresso.ecom.checkout.delivery.gls.parcelshops = data.parcelshops;
            espresso.ecom.checkout.delivery.gls.renderResults();
            //Gem det postnummer som er brugt til at lave gls opslaget så vi kan v´lave det samme opslag igen hvis brugeren går tilbage til leverings steppet senere i forløbet
            jQuery( '#EspressoGLSshopSearchString' ).val( strZipCode );
            if ( jQuery( '#EspressoGLSshopID' ).val() !== '' ) {
                //Hvis vi kommer herind er der allerede valgt en pakkeshop og den skal derfor markers/vælges
                jQuery( '#gls-' + jQuery( '#EspressoGLSshopID' ).val() ).prop( 'checked', true ).trigger( 'change' );
            }
        } );
    };
    espresso.ecom.checkout.delivery.gls.renderResults = function () {
        var jDeliveryGLSshops = jQuery( '<div class="controls gls-shops"></div>' );
        jQuery.each( espresso.ecom.checkout.delivery.gls.parcelshops, function ( key, val ) {
            if ( key % 2 === 0 ) {
                jDeliveryGLSshops.append( '<div class="row-fluid">' + '<div class="span6">' + '<label class="radio" for="gls-' + espresso.ecom.checkout.delivery.gls.parcelshops[ key ].Number + '">' + '<input type="radio" class="required" name="gls-shop" id="gls-' + espresso.ecom.checkout.delivery.gls.parcelshops[ key ].Number + '" value="' + key + '">' + '<strong>' + val.CompanyName + '</strong><br><small>' + val.Streetname2 + '</small><br>' + val.Streetname + '<br>' + val.ZipCode + ' ' + val.CityName + '<br>' + '</label>' + '</div>' + ( key + 1 < espresso.ecom.checkout.delivery.gls.parcelshops.length ? '<div class="span6">' + '<label class="radio" for="gls-' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Number + '">' + '<input type="radio" class="required" name="gls-shop" id="gls-' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Number + '" value="' + ( key + 1 ) + '">' + '<strong>' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].CompanyName + '</strong><br><small>' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Streetname2 + '</small><br>' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].Streetname + '<br>' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].ZipCode + ' ' + espresso.ecom.checkout.delivery.gls.parcelshops[ key + 1 ].CityName + '</label>' + '</div>' : '' ) + '</div>' );
            }
        } );
        var jDeliveryGLS = jQuery( '#DeliveryGLS' );
        jDeliveryGLS.find( '.gls-shops' ).replaceWith( jDeliveryGLSshops );
    };
    espresso.ecom.checkout.delivery.gls.selectShop = function ( selectedIndex ) {
        jQuery( '#EspressoGLSshopID' ).val( espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].Number );
        jQuery( '#EcomOrderDeliveryName' ).val( espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].CompanyName );
        jQuery( '#EcomOrderDeliveryCompany' ).val( 'GLS ' + espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].Streetname2 );
        jQuery( '#EcomOrderDeliveryAddress' ).val( espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].Streetname );
        jQuery( '#EcomOrderDeliveryZip' ).val( espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].ZipCode );
        jQuery( '#EcomOrderDeliveryCity' ).val( espresso.ecom.checkout.delivery.gls.parcelshops[ selectedIndex ].CityName );
    };
    /* Post norden */
    espresso.ecom.checkout.delivery.postdk = {};
    espresso.ecom.checkout.delivery.postdk.settings = {
        url: '/pnlookup.ashx',
        jZipCodeInputField: jQuery( '#EcomOrderCustomerZip' ),
        jAddressInputField: jQuery( '#EcomOrderCustomerAddress' ),
        jSearchStringInputField: jQuery( '#EspressoPostDKshopSearchString' )
    };
    espresso.ecom.checkout.delivery.postdk.parcelshops = {};
    espresso.ecom.checkout.delivery.postdk.init = function () {
        var jEspressoPostDKshopSearchString = jQuery( '#EspressoPostDKshopSearchString' ).on( 'change blur', function () {
            jEspressoPostDKshopSearchString.data( 'changed', true );
        } ).on( 'keypress', function ( event ) {
            if ( event.which === 13 ) {
                event.preventDefault();
                jQuery( '#EspressoPostDKshopSearchStringUpdate' ).triggerHandler( 'click' );
            }
        } );
        var jCo3EspressoPostDKAddress = jQuery( '#Co3EspressoPostDKAddress' ).on( 'change blur', function () {
            jCo3EspressoPostDKAddress.data( 'changed', true );
        } ).on( 'keypress', function ( event ) {
            if ( event.which === 13 ) {
                event.preventDefault();
                jQuery( '#EspressoPostDKshopSearchStringUpdate' ).triggerHandler( 'click' );
            }
        } );
        // Move zipcode from DW standard field to PostDK field
        espresso.ecom.checkout.delivery.postdk.settings.jZipCodeInputField.on( 'change', function () {
            if ( jEspressoPostDKshopSearchString.data( 'changed' ) !== true ) {
                jEspressoPostDKshopSearchString.val( espresso.ecom.checkout.delivery.postdk.settings.jZipCodeInputField.val() );
                jQuery( '#EspressoPostDKshopSearchStringUpdate' ).triggerHandler( 'click' );
            }
        } );
        // Move address from DW standard field to PostDK field
        espresso.ecom.checkout.delivery.postdk.settings.jAddressInputField.on( 'blur', function () {
            if ( jCo3EspressoPostDKAddress.data( 'changed' ) !== true ) {
                jCo3EspressoPostDKAddress.val( espresso.ecom.checkout.delivery.postdk.settings.jAddressInputField.val() );
                jQuery( '#EspressoPostDKshopSearchStringUpdate' ).triggerHandler( 'click' );
            }
        } );
        jEspressoPostDKshopSearchString.on( 'keydown keypress keyup', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                if ( jEspressoPostDKshopSearchString.val().length >= 4 && jEspressoPostDKshopSearchString.data( 'value' ) !== jEspressoPostDKshopSearchString.val() ) {
                    espresso.ecom.checkout.delivery.postdk.lookup( jEspressoPostDKshopSearchString.val() );
                    jEspressoPostDKshopSearchString.data( 'value', jEspressoPostDKshopSearchString.val() );
                }
            }
        } );
        jQuery( '#EspressoPostDKshopSearchStringUpdate' ).on( 'click', function ( event ) {
            jEspressoPostDKshopSearchString.valid();
            event.preventDefault();
            var address = jCo3EspressoPostDKAddress.val();
            if ( jEspressoPostDKshopSearchString.val().length >= 4 ) {
                espresso.ecom.checkout.delivery.postdk.lookup( jEspressoPostDKshopSearchString.val(), address );
            }
        } );
        jQuery( '#js-e-postdk-result-container' ).on( 'change click', 'input[name="postdk-shop"]', function () {
            espresso.ecom.checkout.delivery.postdk.selectShop( jQuery( 'input[name="postdk-shop"]' ).index( this ) );
        } );
    };
    espresso.ecom.checkout.delivery.postdk.select = function () {
        var jEspressoPostDKshopSearchString = jQuery( '#EspressoPostDKshopSearchString' );
        if ( jEspressoPostDKshopSearchString.data( 'changed' ) === true && jEspressoPostDKshopSearchString.valid() === 1 ) {
            espresso.ecom.checkout.delivery.postdk.lookup( jEspressoPostDKshopSearchString.val() );
        }
        else if ( espresso.ecom.checkout.delivery.postdk.settings.jSearchStringInputField.val() !== '' ) {
            espresso.ecom.checkout.delivery.postdk.lookup( espresso.ecom.checkout.delivery.postdk.settings.jSearchStringInputField.val() );
        }
        else if ( espresso.ecom.checkout.delivery.postdk.settings.jZipCodeInputField.val() !== '' ) {
            espresso.ecom.checkout.delivery.postdk.lookup( espresso.ecom.checkout.delivery.postdk.settings.jZipCodeInputField.val() );
        }
        jQuery( '#DeliveryPostDK' ).parent().slideDown( 'fast' );
    };
    espresso.ecom.checkout.delivery.postdk.deSelect = function () {
        espresso.ecom.checkout.delivery.address.clear();
        jQuery( '#EspressoPostDKshopSearchString' ).val( '' ).data( 'changed', false );
        jQuery( '#EspressoPostDKshopID' ).val( '' );
        jQuery( '#DeliveryPostDK' ).parent().slideUp( 'fast' );
    };
    espresso.ecom.checkout.delivery.postdk.lookup = function ( strZipCode, strAddress ) {
        //console.log( 'lookup', strZipCode, strAddress );
        var jLoading = jQuery( '#DeliveryPostDK .js-e-loading-element' ).removeClass( 'hidden' );
        jQuery( '#js-e-postdk-result-container .postdk-shops' ).html( '' );
        espresso.ecom.checkout.delivery.postdk.hideError();
        var url = espresso.ecom.checkout.delivery.postdk.settings.url + '?countryCode=' + jQuery( '#EcomOrderCustomerCountry' ).val() + '&postalCode=' + encodeURIComponent( jQuery.trim( strZipCode.replace( / /g, '' ) ) ) + '&numberOfServicePoints=6';
        if ( strAddress !== undefined && strAddress.length > 0 ) {
            url += '&streetName=' + encodeURIComponent( jQuery.trim( strAddress.replace( / /g, '' ) ) );
        }
        jQuery.ajax( {
            url: url,
            cache: false,
            success: function ( data ) {
                if ( data.error === undefined ) {
                    espresso.ecom.checkout.delivery.postdk.parcelshops = data.servicePointInformationResponse.servicePoints;
                    espresso.ecom.checkout.delivery.postdk.renderResults();
                    jQuery( '#EspressoPostDKshopSearchString' ).val( strZipCode );
                    if ( jQuery( '#EspressoPostDKshopID' ).val() !== '' ) {
                        //Hvis vi kommer herind er der allerede valgt en pakkeshop og den skal derfor markers/vælges
                        jQuery( '#postdk-' + jQuery( '#EspressoPostDKshopID' ).val() ).prop( 'checked', true ).trigger( 'change' );
                    }
                    jLoading.addClass( 'hidden' );
                }
                else {
                    jLoading.addClass( 'hidden' );
                    espresso.ecom.checkout.delivery.postdk.showError();
                }
            }
        } );
    };
    espresso.ecom.checkout.delivery.postdk.renderResults = function () {
        var jDeliveryPostDKshops = jQuery( '<div class="controls postdk-shops"></div>' );
        var currentShopID = jQuery( '#EspressoPostDKshopID' ).val();
        jQuery.each( espresso.ecom.checkout.delivery.postdk.parcelshops, function ( key, val ) {
            if ( key % 2 === 0 ) {
                var htmlElm = [ '<div class="row-fluid">', '<div class="span6">', '<label class="radio">', '<input type="radio" class="required" name="postdk-shop" ' + ( currentShopID === espresso.ecom.checkout.delivery.postdk.parcelshops[ key ].servicePointId ? 'checked="checked"' : '' ) + ' id="postdk-' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key ].servicePointId + '" value="' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key ].servicePointId + '">', '<strong>' + val.name + '</strong><br>' + val.visitingAddress.streetName + ' ' + val.visitingAddress.streetNumber + '<br>',
                    val.visitingAddress.postalCode + ' ' + val.visitingAddress.city + '<br>' + '</label>', '</div>'
                ];
                if ( key + 1 < espresso.ecom.checkout.delivery.postdk.parcelshops.length ) {
                    var htmlElm2 = [ '<div class="span6">', '<p><label class="radio" >', '<input type="radio" class="required" name="postdk-shop" ' + ( currentShopID === espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].servicePointId ? 'checked="checked"' : '' ) + ' id="postdk-' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].servicePointId + '" value="' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].servicePointId + '">', '<strong>' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].name + '</strong><br>', '' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].visitingAddress.streetName + ' ' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].visitingAddress.streetNumber + '<br>',
                        espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].visitingAddress.postalCode + ' ' + espresso.ecom.checkout.delivery.postdk.parcelshops[ key + 1 ].deliveryAddress.city, '</label></p>', '</div>'
                    ].join( '' );
                    htmlElm.push( htmlElm2 );
                }
                htmlElm.push( '</div>' );
                jDeliveryPostDKshops.append( htmlElm.join( '' ) );
            }
        } );
        var jDeliveryPostDK = jQuery( '#js-e-postdk-result-container' );
        jDeliveryPostDK.find( '.postdk-shops' ).replaceWith( jDeliveryPostDKshops );
    };
    espresso.ecom.checkout.delivery.postdk.showError = function () {
        var jDeliveryPostDK = jQuery( '#js-e-postdk-result-container' );
        jDeliveryPostDK.find( '.js-postdk-nothing-found' ).removeClass( 'hidden' );
    };
    espresso.ecom.checkout.delivery.postdk.hideError = function () {
        var jDeliveryPostDK = jQuery( '#js-e-postdk-result-container' );
        jDeliveryPostDK.find( '.js-postdk-nothing-found' ).addClass( 'hidden' );
    };
    espresso.ecom.checkout.delivery.postdk.selectShop = function ( selectedIndex ) {
        jQuery( '#EspressoPostDKshopID' ).val( espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].servicePointId );
        jQuery( '#EcomOrderDeliveryName' ).val( espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].name );
        jQuery( '#EcomOrderDeliveryCompany' ).val( 'Post Danmark ' + espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].servicePointId );
        jQuery( '#EcomOrderDeliveryAddress' ).val( espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].deliveryAddress.streetName + ' ' + espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].deliveryAddress.streetNumber );
        jQuery( '#EcomOrderDeliveryZip' ).val( espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].deliveryAddress.postalCode );
        jQuery( '#EcomOrderDeliveryCity' ).val( espresso.ecom.checkout.delivery.postdk.parcelshops[ selectedIndex ].deliveryAddress.city );
    };
    espresso.ecom.checkout.payment = function () {
        var jCheckoutPaymentForm = jQuery( 'form[name="CheckoutPaymentForm"]' );
        if ( jCheckoutPaymentForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-payment' ).addClass( 'step-active' );
        }
        var jPaymentMethods = jQuery( '#PaymentMethods' ).find( 'input[name="EcomCartPaymethodID"]' );
        if ( jPaymentMethods.filter( ':checked' ).length === 0 ) {
            jPaymentMethods.first().prop( 'checked', true );
        }
        //jPaymentMethods.filter(':checked').triggerHandler('change');
    };
    espresso.ecom.checkout.approve = function () {
        var jCheckoutApproveForm = jQuery( 'form[name="CheckoutApproveForm"]' );
        if ( jCheckoutApproveForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-approve' ).addClass( 'step-active' );
            //jCheckoutApproveForm.validate( {} );
            jCheckoutApproveForm.find( '.PreviousStepButton' ).on( 'click', function () { //unbind hvis der klikkes på tilbage
                jCheckoutApproveForm.off( 'submit' );
            } );
            //Hente handelsbetingelser til modal
            var jTermsAndConditionsModal = jQuery( '#TermsAndConditions .modal' ).on( 'shown', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().focus();
            } ).on( 'hide', function () {
                jQuery( this ).find( 'button[data-dismiss="modal"]' ).first().blur();
            } );
            jTermsAndConditionsModal.find( '.modal-body .row-fluid' ).load( jTermsAndConditionsModal.find( 'a' ).attr( 'href' ) + ' .featured .row [class*=span]' );
            jTermsAndConditionsModal.find( '.modal-footer .btn-primary' ).on( 'click', function () {
                jQuery( '#EcomOrderCustomerAccepted' ).prop( 'checked', true ).valid();
            } );
        }
    };
    espresso.ecom.checkout.receipt = function () {
        var jCheckoutReceiptForm = jQuery( 'form[name="CheckoutReceiptForm"]' );
        if ( jCheckoutReceiptForm.length === 1 ) {
            jQuery( '.e-checkout-progress .step-receipt' ).addClass( 'step-active' );
        }
    };
}() );
